/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_5Inputs */

const en_cp_give_5 = /** @type {(inputs: Cp_Give_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder & Problem Solver templates in the wizard, proposal PDF, public benchmark`)
};

const id_cp_give_5 = /** @type {(inputs: Cp_Give_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Builder & Problem Solver di wizard, proposal PDF, benchmark publik`)
};

/**
* | output |
* | --- |
* | "Builder & Problem Solver templates in the wizard, proposal PDF, public benchmark" |
*
* @param {Cp_Give_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_5 = /** @type {((inputs?: Cp_Give_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_5(inputs)
	return en_cp_give_5(inputs)
});